var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "top"
  }, [_c("router-link", {
    staticClass: "header",
    staticStyle: {
      left: "auto",
      right: "20px"
    },
    attrs: {
      to: "/index"
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: require("./image/workshop/logo.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("智慧渔业管控平台")])])], 1), _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "left"
  }, [_c("div", [_c("div", {
    staticClass: "item other-item"
  }, [_c("div", {
    staticClass: "search-container"
  }, [_c("div", [_vm._v("溯源批次查询")]), _c("img", {
    attrs: {
      src: require("./image/largeSource/search-bg-icon.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "input"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeSource/search.png"),
      alt: ""
    }
  }), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.productName,
      expression: "productName"
    }],
    attrs: {
      type: "text",
      placeholder: "请输入产品名称"
    },
    domProps: {
      value: _vm.productName
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.productName = $event.target.value;
      }
    }
  })])]), _c("div", {
    staticClass: "qrcode-container"
  }, [_vm.qrCode ? _c("img", {
    staticClass: "code-img",
    attrs: {
      src: _vm.qrCode,
      alt: ""
    }
  }) : _vm._e()])]), _c("div", {
    staticClass: "item location-item"
  }, [_vm._m(0), _c("div", {
    staticClass: "table"
  }, [_vm._m(1), _c("div", {
    staticClass: "td-list"
  }, [_vm._l(_vm.sourceBatchList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "td",
      class: {
        "td-active": _vm.sourceBatchData.id == item.id
      },
      on: {
        click: function click($event) {
          return _vm.sourceBatchClick(item);
        }
      }
    }, [_c("div", {
      staticClass: "tr one-overflow"
    }, [_vm._v(_vm._s(item.productName || "--"))]), _c("div", {
      staticClass: "tr one-overflow",
      staticStyle: {
        width: "60px",
        flex: "none"
      }
    }, [_vm._v(_vm._s(item.productAmount))]), _c("div", {
      staticClass: "tr one-overflow",
      staticStyle: {
        width: "154px",
        flex: "none"
      }
    }, [_vm._v(_vm._s(item.createTime ? _vm.dayjs(item.createTim).format("YYYY-MM-DD HH:mm:ss") : ""))])]);
  }), !_vm.sourceBatchList.length ? _c("div", {
    staticStyle: {
      height: "100px",
      "line-height": "100px",
      color: "#fff",
      "text-align": "center",
      opacity: "0.5"
    }
  }, [_vm._v("暂无数据")]) : _vm._e()], 2)])]), _vm._m(2)]), _c("div", [_c("div", {
    staticClass: "item product-introduction-item"
  }, [_vm._m(3), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "info-list"
  }, [_c("div", {
    staticClass: "info-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("产品名称：")]), _c("div", {
    staticClass: "value one-overflow"
  }, [_vm._v(_vm._s(_vm.sourceBatchData.productName || "--"))])]), _c("div", {
    staticClass: "info-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("产品数量：")]), _c("div", {
    staticClass: "value one-overflow"
  }, [_vm._v(_vm._s(_vm.sourceBatchData.productAmount || "--"))])]), _c("div", {
    staticClass: "info-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("产品编码：")]), _c("div", {
    staticClass: "value one-overflow"
  }, [_vm._v(_vm._s(_vm.sourceBatchData.productCode || "--"))])]), _c("div", {
    staticClass: "info-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("生产保质期：")]), _c("div", {
    staticClass: "value one-overflow"
  }, [_vm._v(_vm._s(_vm.sourceBatchData.productShelfLife || "--") + "天")])]), _c("div", {
    staticClass: "info-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("产品图片：")]), _c("div", {
    staticClass: "value one-overflow"
  }, [_vm._v(_vm._s(_vm.sourceBatchData.productName || "--"))])])]), _c("div", {
    staticClass: "introduction"
  }, [_vm._m(4), _c("div", {
    staticClass: "introduction-text"
  }, [_c("pre", [_vm._v(_vm._s(_vm.sourceBatchData.productDescription || "--"))])])])])]), _c("div", {
    staticClass: "item meteorological-item"
  }, [_vm._m(5), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "info-list"
  }, [_c("div", {
    staticClass: "info-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("商家名称：")]), _c("div", {
    staticClass: "value one-overflow"
  }, [_vm._v(_vm._s(_vm.sourceBatchData.merchantName || "--"))])]), _c("div", {
    staticClass: "info-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("信用代码：")]), _c("div", {
    staticClass: "value one-overflow"
  }, [_vm._v(_vm._s(_vm.sourceBatchData.merchantCreditCode || "--"))])]), _c("div", {
    staticClass: "info-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("联系人：")]), _c("div", {
    staticClass: "value one-overflow"
  }, [_vm._v(_vm._s(_vm.sourceBatchData.merchantContact || "--"))])]), _c("div", {
    staticClass: "info-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("联系方式：")]), _c("div", {
    staticClass: "value one-overflow"
  }, [_vm._v(_vm._s(_vm.sourceBatchData.merchantContactPhone || "--"))])]), _c("div", {
    staticClass: "info-item"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("详细地址：")]), _c("div", {
    staticClass: "value one-overflow"
  }, [_vm._v(_vm._s(_vm.sourceBatchData.merchantAddress || "--"))])])])])])])]), _vm._m(6)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item-title"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeSource/title-bg.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("溯源批次")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "th"
  }, [_c("div", {
    staticClass: "tr"
  }, [_vm._v("产品名称")]), _c("div", {
    staticClass: "tr",
    staticStyle: {
      width: "60px",
      flex: "none"
    }
  }, [_vm._v("数量")]), _c("div", {
    staticClass: "tr",
    staticStyle: {
      width: "154px",
      flex: "none"
    }
  }, [_vm._v("创建时间")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item static-item"
  }, [_c("div", {
    staticClass: "item-title"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeSource/title-bg.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("溯源统计-批次扫码量")])]), _c("div", {
    attrs: {
      id: "chartDom"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item-title"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeSource/title-bg.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("产品信息")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "introduction-title"
  }, [_c("div", [_vm._v("产品描述")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "item-title"
  }, [_c("img", {
    attrs: {
      src: require("./image/largeSource/title-bg.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("商家信息")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "right"
  }, [_c("div", {
    staticStyle: {
      width: "100%",
      height: "100%"
    },
    attrs: {
      id: "map"
    }
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };